import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from "react";
import { scImageType, scLinkType, scStringType } from "../../types";
import Wrapper from "../wrapper/Wrapper";
import { IoMdClose } from "react-icons/io";
import { Col, Container, Row } from "react-bootstrap";
import { Image } from "@sitecore-jss/sitecore-jss-react";
import LoyaltySignUpForm from "./LoyaltySignUpForm";
import { AuthenticationState } from 'react-aad-msal';

var LoyaltySignUp = /*#__PURE__*/function (_Component) {
  _inherits(LoyaltySignUp, _Component);

  var _super = _createSuper(LoyaltySignUp);

  function LoyaltySignUp(props) {
    var _this;

    _classCallCheck(this, LoyaltySignUp);

    _this = _super.call(this, props);
    _this.state = {
      forceLogout: true
    };
    return _this;
  }

  _createClass(LoyaltySignUp, [{
    key: "render",
    value: function render() {
      var _image,
          _cancelUrl,
          _this2 = this;

      var _this$props = this.props,
          emailAddress = _this$props.emailAddress,
          token = _this$props.token,
          handleGetUserInfo = _this$props.handleGetUserInfo,
          store = _this$props.store,
          handleLogout = _this$props.handleLogout,
          authenticationState = _this$props.authenticationState;

      var _ref = this.props.model || {},
          header = _ref.header,
          image = _ref.image,
          cancelUrl = _ref.cancelUrl,
          firstNamePlaceholder = _ref.firstNamePlaceholder,
          emailPlaceholder = _ref.emailPlaceholder,
          submitLabel = _ref.submitLabel,
          emailValidationError = _ref.emailValidationError,
          submitError = _ref.submitError,
          firstNameValidationError = _ref.firstNameValidationError,
          lastNamePlaceholder = _ref.lastNamePlaceholder,
          lastNameValidationError = _ref.lastNameValidationError,
          phoneNumberPlaceholder = _ref.phoneNumberPlaceholder,
          phoneNumberValidationError = _ref.phoneNumberValidationError,
          birthdayCopy = _ref.birthdayCopy,
          monthPlaceholder = _ref.monthPlaceholder,
          dayPlaceholder = _ref.dayPlaceholder,
          legalCheckboxCopy = _ref.legalCheckboxCopy;

      var title = header === null || header === void 0 ? void 0 : header.value;
      image = (_image = image) === null || _image === void 0 ? void 0 : _image.value;
      cancelUrl = (_cancelUrl = cancelUrl) === null || _cancelUrl === void 0 ? void 0 : _cancelUrl.value;
      var labelFirstName = firstNamePlaceholder === null || firstNamePlaceholder === void 0 ? void 0 : firstNamePlaceholder.value;
      var labelEmail = emailPlaceholder === null || emailPlaceholder === void 0 ? void 0 : emailPlaceholder.value;
      var btnText = submitLabel === null || submitLabel === void 0 ? void 0 : submitLabel.value;
      var errorEmail = emailValidationError === null || emailValidationError === void 0 ? void 0 : emailValidationError.value;
      var errorSubmit = submitError === null || submitError === void 0 ? void 0 : submitError.value;
      var errorFirstName = firstNameValidationError === null || firstNameValidationError === void 0 ? void 0 : firstNameValidationError.value;
      var labelLastName = lastNamePlaceholder === null || lastNamePlaceholder === void 0 ? void 0 : lastNamePlaceholder.value;
      var errorLastName = lastNameValidationError === null || lastNameValidationError === void 0 ? void 0 : lastNameValidationError.value;
      var labelPhoneNumber = phoneNumberPlaceholder === null || phoneNumberPlaceholder === void 0 ? void 0 : phoneNumberPlaceholder.value;
      var errorPhoneNumber = phoneNumberValidationError === null || phoneNumberValidationError === void 0 ? void 0 : phoneNumberValidationError.value;
      var copyBirthday = birthdayCopy === null || birthdayCopy === void 0 ? void 0 : birthdayCopy.value;
      var labelBirthdayMonth = monthPlaceholder === null || monthPlaceholder === void 0 ? void 0 : monthPlaceholder.value;
      var labelBirthdayDay = dayPlaceholder === null || dayPlaceholder === void 0 ? void 0 : dayPlaceholder.value;
      var copyLegal = legalCheckboxCopy === null || legalCheckboxCopy === void 0 ? void 0 : legalCheckboxCopy.value;

      var handleCloseButton = /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
          var _this2$state, _cancelUrl2;

          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(((_this2$state = _this2.state) === null || _this2$state === void 0 ? void 0 : _this2$state.forceLogout) && authenticationState === AuthenticationState.Authenticated)) {
                    _context.next = 3;
                    break;
                  }

                  _context.next = 3;
                  return handleLogout();

                case 3:
                  window.location.href = ((_cancelUrl2 = cancelUrl) === null || _cancelUrl2 === void 0 ? void 0 : _cancelUrl2.href) || "/";

                case 4:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function handleCloseButton() {
          return _ref2.apply(this, arguments);
        };
      }();

      var setForceLogout = function setForceLogout(value) {
        _this2.setState({
          forceLogout: value
        });
      };

      return /*#__PURE__*/React.createElement(Wrapper, {
        className: "loyalty--sign-up"
      }, /*#__PURE__*/React.createElement("button", {
        className: "reward-selection-modal-error__close loyalty--sign-up__close",
        onClick: handleCloseButton
      }, /*#__PURE__*/React.createElement(IoMdClose, null)), /*#__PURE__*/React.createElement(Container, {
        className: "loyalty--sign-up__container"
      }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("h1", {
        className: "loyalty--sign-up__title"
      }, title), /*#__PURE__*/React.createElement("figure", {
        className: "loyalty--sign-up__image"
      }, /*#__PURE__*/React.createElement(Image, {
        field: image
      })), /*#__PURE__*/React.createElement(LoyaltySignUpForm, {
        store: store,
        token: token,
        emailAddress: emailAddress,
        errorEmail: errorEmail,
        labelEmail: labelEmail,
        labelFirstName: labelFirstName,
        errorFirstName: errorFirstName,
        labelLastName: labelLastName,
        errorLastName: errorLastName,
        labelPhoneNumber: labelPhoneNumber,
        errorPhoneNumber: errorPhoneNumber,
        copyBirthday: copyBirthday,
        labelBirthdayMonth: labelBirthdayMonth,
        labelBirthdayDay: labelBirthdayDay,
        copyLegal: copyLegal,
        btnText: btnText,
        errorSubmit: errorSubmit,
        handleGetUserInfo: handleGetUserInfo,
        handleLogout: handleLogout,
        authenticationState: authenticationState,
        setForceLogout: setForceLogout
      })))));
    }
  }]);

  return LoyaltySignUp;
}(Component);

export default LoyaltySignUp;